import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addBuyerAddress, type BuyerAddressPayload } from "@/lib/api/buyer.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddBuyerAddress() {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: BuyerAddressPayload) => {
      if (!token) throw new Error("No token available")
      return addBuyerAddress(payload, token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["buyer-profile"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-addresses"] })
    },
  })
}
